import {css, unsafeCSS} from "lit";
import {sbkCoreBreakpointLg} from "@/tokens/variables";

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const style = css`
    :host {
        --headline-link__border--focus: var(--_headline-link__border--focus, var(--sbkHeadlineLinkBorderOnLightFocus));

        --headline-link__color: var(--_headline-link__color, var(--sbkHeadlineLinkFgColorOnLightEnabled));
        --headline-link__color--hover: var(--_headline-link__color--hover, var(--sbkHeadlineLinkFgColorOnLightHover));
        --headline-link__color--active: var(--_headline-link__color--active, var(--sbkHeadlineLinkFgColorOnLightActive));
        --headline-link__color--disabled: var(--_headline-link__color--disabled, var(--sbkHeadlineLinkFgColorOnLightDisabled));
        --headline-link__color--visited: var(--_headline-link__color--visited, var(--sbkHeadlineLinkFgColorOnLightVisited));
        box-sizing: border-box;
        width: 100%;
    }


    a, span {
        text-decoration: none;
        hyphens: auto;
        color: var(--headline-link__color);
        outline: 2px solid transparent;
        outline-offset: var(--sbkLinkBorderGapFocus);
        border-radius: var(--sbkLinkBorderRadiusFocus);
        border: none;
        cursor: pointer;

        @media (hover: hover) and (pointer: fine) {
            &:hover {
                color: var(--headline-link__color--hover);
                text-decoration: underline;
            }
        }

        &:active {
            color: var(--headline-link__color--active);
            text-decoration: underline;
        }

        &:visited {
            color: var(--headline-link__color--visited);
            text-decoration: underline;
        }

        &:disabled {
            color: var(--headline-link__color--disabled);
            pointer-events: none;
        }

        &:focus-visible {
            outline: var(--headline-link__border--focus);
        }
    }

    .icon {
        box-sizing: border-box;
        vertical-align: sub;
        fill: currentColor;
    }

    .xxl {
        font: var(--sbkHeadlineLinkTypographySmallScrBold2xl);

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBold2xl);
        }
    }

    .xxl.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlined2xl);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlined2xl);
        }
    }

    .xl {
        font: var(--sbkHeadlineLinkTypographySmallScrBoldXl);

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldXl);
        }
    }

    .xs.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlinedXl);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlinedXl);
        }
    }

    .lg {
        font: var(--sbkHeadlineLinkTypographySmallScrBoldLg);

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldLg);
        }
    }

    .lg.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlinedLg);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlinedLg);
        }
    }

    .md {
        font: var(--sbkHeadlineLinkTypographySmallScrBoldMd);

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldMd);
        }
    }

    .md.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlinedMd);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlinedMd);
        }
    }

    .sm {
        font: var(--sbkHeadlineLinkTypographySmallScrBoldSm);

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldSm);
        }
    }

    .sm.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlinedSm);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlinedSm);
        }
    }

    .xs {
        font: var(--sbkHeadlineLinkTypographySmallScrBoldXs);

        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldXs);
        }
    }

    .xs.underlined {
        font: var(--sbkHeadlineLinkTypographySmallScrTitleUnderlinedXs);
        text-decoration: underline;
        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkHeadlineLinkTypographyLargeScrBoldUnderlinedXs);
        }
    }

    .icon-xs {
        height: var(--sbkHeadlineLinkSizingSmallScrXs);
        width: var(--sbkHeadlineLinkSizingSmallScrXs);
        @media all and (min-width: ${breakpointLg}) {
            height: var(--sbkHeadlineLinkSizingLargeScrXs);
            width: var(--sbkHeadlineLinkSizingLargeScrXs);
        }
    }

    .icon-sm {
        height: var(--sbkHeadlineLinkSizingSmallScrSm);
        width: var(--sbkHeadlineLinkSizingSmallScrSm);
        @media all and (min-width: ${breakpointLg}) {
            height: var(--sbkHeadlineLinkSizingLargeScrSm);
            width: var(--sbkHeadlineLinkSizingLargeScrSm);
        }
    }

    .icon-md {
        height: var(--sbkHeadlineLinkSizingSmallScrMd);
        width: var(--sbkHeadlineLinkSizingSmallScrMd);
        @media all and (min-width: ${breakpointLg}) {
            height: var(--sbkHeadlineLinkSizingLargeScrMd);
            width: var(--sbkHeadlineLinkSizingLargeScrMd);
        }
    }

    .icon-lg {
        height: var(--sbkHeadlineLinkSizingSmallScrLg);
        width: var(--sbkHeadlineLinkSizingSmallScrLg);
        @media all and (min-width: ${breakpointLg}) {
            height: var(--sbkHeadlineLinkSizingLargeScrLg);
            width: var(--sbkHeadlineLinkSizingLargeScrLg);
        }
    }

    .icon-xl {
        height: var(--sbkHeadlineLinkSizingSmallScrXl);
        width: var(--sbkHeadlineLinkSizingSmallScrXl);
        @media all and (min-width: ${breakpointLg}) {
            height: var(--sbkHeadlineLinkSizingLargeScrXl);
            width: var(--sbkHeadlineLinkSizingLargeScrXl);
        }
    }

    .icon-xxl {
        height: var(--sbkHeadlineLinkSizingSmallScr2xl);
        width: var(--sbkHeadlineLinkSizingSmallScr2xl);
        @media all and (min-width: ${breakpointLg}) {
            height: var(--sbkHeadlineLinkSizingLargeScr2xl);
            width: var(--sbkHeadlineLinkSizingLargeScr2xl);
        }
    }

`;

